import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { userPermissionsSelector } from 'store/auth/userSlice'

/**
 * Hook to check if user has a specific permission
 * @param {string} permission - Permission to check
 * @returns {boolean} - True if user has the permission
 */
function usePermission(permission) {
    const userPermissions = useSelector(userPermissionsSelector)
    // console.log('userPermissions', userPermissions)
    return useMemo(() => {
        if (!permission) return true // No permission required = allowed
        if (!userPermissions || userPermissions.length === 0) return false
        return userPermissions.includes(permission)
    }, [permission, userPermissions])
}

export default usePermission
